import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import { A } from 'components/common/Link/Link'
import { SELECT_STORE_TITLE, APPLY_TODAY_TITLE } from 'components/CareersPage/constants'

const SelectOrApplyButton = ({
  hasSelectedStore,
  showStoreLocatorModal,
  isExternalLink,
  url
}) =>
  hasSelectedStore ?
    <A
      button
      data-at-careers-link
      href={ url }
      rel={ isExternalLink ? 'noopener noreferrer' : undefined }
      target="_blank">
      { APPLY_TODAY_TITLE }
    </A>
    :
    <Button
      data-at-careers-btn
      onClick={ showStoreLocatorModal }>
      { SELECT_STORE_TITLE }
    </Button>

SelectOrApplyButton.propTypes = {
  hasSelectedStore: PropTypes.bool,
  isExternalLink: PropTypes.bool,
  showStoreLocatorModal: PropTypes.func,
  url: PropTypes.string
}

export default SelectOrApplyButton
